var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.639,14.9C9.871,14.9,5.9,17.6,5.9,18.786v2.036H21.378V18.786C21.378,17.6,17.407,14.9,13.639,14.9Z",
    transform: "translate(-1.639 -0.542)",
    fill: "#2e80c3",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.111,14.25C10.07,14.25,4,15.776,4,18.806v3.417H22.222V18.806C22.222,15.776,16.152,14.25,13.111,14.25Zm6.947,5.808H6.164V18.806c0-.729,3.565-2.392,6.947-2.392s6.947,1.663,6.947,2.392Zm-6.947-6.947A4.556,4.556,0,1,0,8.556,8.556,4.554,4.554,0,0,0,13.111,13.111Zm0-6.947a2.392,2.392,0,1,1-2.392,2.392A2.391,2.391,0,0,1,13.111,6.164Z",
    transform: "translate(-1.111 -1.111)",
    fill: "#2e80c3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmail);
export default __webpack_public_path__ + "static/media/login_email.8a570320ba409a418ea1f1ea0da5f853.svg";
export { ForwardRef as ReactComponent };